import axios from 'axios';

import { appConfig } from '../config.js';


export default axios.create({
  baseURL: appConfig.api.URL,
  params: {
  }
});